
/**
 * Do Wistia
 * @function doWistia
 * @param {value} wistiaId
 * @param {string} wistiaType
 */
const doWistia = (wistiaId, wistiaType) => {

    var baseUrl = "https://fast.wistia.com/oembed/?url=";
    var accountUrl = encodeURIComponent("https://home.wistia.com/medias/");

    var xhr = new XMLHttpRequest();

    xhr.open('GET', baseUrl + accountUrl + wistiaId + "&format=json&callback=?");
    xhr.send(null);

    xhr.onreadystatechange = function () {
        var DONE = 4;
        var OK = 200;

        if (xhr.readyState === DONE) {

            if (xhr.status === OK) {
                let wistiaEmbed;

                switch (wistiaType) {
                    case "popover":
                        wistiaEmbed = Wistia.embed(wistiaId, {
                            autoPlay: true,
                            controlsVisibleOnLoad: false,
                            popover: true,
                            popoverAnimateThumbnail: true,
                            videoFoam: true,
                            videoWrapper: 'wistia_embed_popover',
                        });
                        break;

                    case "inline":
                        wistiaEmbed = Wistia.embed(wistiaId, {
                            autoPlay: false,
                            controlsVisibleOnLoad: false,
                            videoFoam: true,
                            videoWrapper: 'wistia_embed_api',
                        });
                        break;
                }
            }
        } else {
            return;
        }
    };
};

/**
 * Setup Wistia
 * @function setupWistia
 * @param {event} e
 */
const setupWistia = (e) => {

    let hasWistia;
    let wistiaPopover = document.querySelectorAll('.wistia_embed_popover')
    let wistiaInline = document.querySelectorAll('.wistia_embed_api')

    if (wistiaPopover.length > 0) {
        hasWistia = true;
    }

    if (wistiaInline.length > 0) {
        hasWistia = true;
    }

    if (hasWistia === true) {
        let d = document;
        let script = d.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.onload = function () {
            injectWistia();
        };
        script.src = 'https://fast.wistia.com/assets/external/E-v1.js';
        d.getElementsByTagName('body')[0].appendChild(script);
    } else {
        return;
    }
};

const injectWistia = () => {
    let wistiaId, wistiaType, hasWistia;
    let wistiaPopover = document.querySelectorAll('.wistia_embed_popover')
    let wistiaInline = document.querySelectorAll('.wistia_embed_api')

    if (wistiaPopover.length > 0) {
        wistiaPopover.forEach((item) => {
            wistiaId = item.getAttribute('data-wistia-id');
            wistiaType = 'popover';
            doWistia(wistiaId, wistiaType);
        });
    }

    if (wistiaInline.length > 0) {
        wistiaInline.forEach((item) => {
            wistiaId = item.getAttribute('data-video');
            wistiaType = 'inline';
            doWistia(wistiaId, wistiaType);
        });
    }
}

export default setupWistia;